import React, { useEffect } from 'react';
import '../../styles/ServicePage.css';

const DatenschutzPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('open-cookie-settings'));
  };

  return (
    <div className="service-page">
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <h1>Datenschutzerklärung</h1>
            <p>Informationen zur Verarbeitung personenbezogener Daten gemäß Art. 13, 14 DSGVO</p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <p style={{ marginBottom: '2rem', fontStyle: 'italic' }}>
              Stand: Mai 2026
            </p>

            {/* 1. Verantwortlicher */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">1. Verantwortlicher</h2>
              <p>
                Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer
                nationaler Datenschutzgesetze der Mitgliedstaaten sowie sonstiger
                datenschutzrechtlicher Bestimmungen ist:
              </p>
              <p>
                <strong>IB Neubaur GmbH</strong><br />
                Nelkenweg 6a<br />
                86641 Rain am Lech<br />
                Deutschland
              </p>
              <p>
                Telefon: +49 (0) 90 90 - 95 900-10<br />
                E-Mail: <a href="mailto:info@neubaur-gmbh.de">info@neubaur-gmbh.de</a><br />
                Geschäftsführer: Gerhard Neubaur
              </p>
              <p>
                Eingetragen im Handelsregister des Amtsgerichts Augsburg, HRB 17175.
              </p>
            </div>

            {/* 2. Datenschutzbeauftragter */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">2. Datenschutzbeauftragter</h2>
              <p>
                Ein Datenschutzbeauftragter ist gemäß Art. 37 DSGVO i.V.m. § 38 BDSG nicht
                bestellt, da die gesetzlichen Voraussetzungen hierfür nicht vorliegen. Bei Fragen
                zum Datenschutz wenden Sie sich bitte direkt an die oben genannte verantwortliche
                Stelle unter <a href="mailto:info@neubaur-gmbh.de">info@neubaur-gmbh.de</a>.
              </p>
            </div>

            {/* 3. Allgemeine Hinweise */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">3. Allgemeine Hinweise zur Datenverarbeitung</h2>

              <h3>3.1 Umfang der Verarbeitung personenbezogener Daten</h3>
              <p>
                Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit
                dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und
                Leistungen erforderlich ist. Die Verarbeitung personenbezogener Daten unserer
                Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers oder wenn eine
                Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
              </p>

              <h3>3.2 Rechtsgrundlagen der Datenverarbeitung</h3>
              <p>
                Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
                betroffenen Person einholen, dient <strong>Art. 6 Abs. 1 lit. a DSGVO</strong> als
                Rechtsgrundlage.
              </p>
              <p>
                Bei der Verarbeitung personenbezogener Daten, die zur Erfüllung eines Vertrages
                erforderlich ist, dessen Vertragspartei die betroffene Person ist, dient
                <strong> Art. 6 Abs. 1 lit. b DSGVO</strong> als Rechtsgrundlage. Dies gilt auch
                für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen
                erforderlich sind.
              </p>
              <p>
                Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
                Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient
                <strong> Art. 6 Abs. 1 lit. c DSGVO</strong> als Rechtsgrundlage.
              </p>
              <p>
                Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres
                Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen,
                Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht,
                so dient <strong>Art. 6 Abs. 1 lit. f DSGVO</strong> als Rechtsgrundlage für die
                Verarbeitung.
              </p>

              <h3>3.3 Datenlöschung und Speicherdauer</h3>
              <p>
                Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt,
                sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus
                erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in
                unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der
                Verantwortliche unterliegt, vorgesehen wurde (insbesondere
                handels- und steuerrechtliche Aufbewahrungspflichten, regelmäßig 6 bzw. 10 Jahre
                gemäß § 257 HGB, § 147 AO).
              </p>
            </div>

            {/* 4. Bereitstellung der Website / Server-Logfiles */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">4. Bereitstellung der Website und Erstellung von Logfiles</h2>
              <p>
                Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten und
                Informationen vom Computersystem des aufrufenden Rechners. Folgende Daten werden
                hierbei erhoben:
              </p>
              <ul>
                <li>IP-Adresse des Nutzers (gekürzt/anonymisiert, soweit möglich)</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Aufgerufene URL / Name der angeforderten Datei</li>
                <li>Übertragene Datenmenge</li>
                <li>Meldung, ob der Abruf erfolgreich war</li>
                <li>Verwendeter Browser und Betriebssystem</li>
                <li>Referrer-URL (zuvor besuchte Seite)</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Auslieferung der Website, Gewährleistung der
                Systemsicherheit und Fehleranalyse.<br />
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
                Interesse an einer technisch fehlerfreien und sicheren Bereitstellung).<br />
                <strong>Speicherdauer:</strong> Die Logfiles werden nach spätestens 7 Tagen
                gelöscht, sofern keine sicherheitsrelevanten Vorfälle eine längere
                Aufbewahrung erfordern.
              </p>
              <p>
                Die Website wird auf Servern unseres Hosting-Dienstleisters in der Europäischen
                Union betrieben. Mit dem Hoster wurde ein Vertrag zur Auftragsverarbeitung gemäß
                Art. 28 DSGVO geschlossen.
              </p>
            </div>

            {/* 5. SSL/TLS-Verschlüsselung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">5. SSL- bzw. TLS-Verschlüsselung</h2>
              <p>
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
                vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
                Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf
                „https://" wechselt und am Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </div>

            {/* 6. Cookies */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">6. Cookies und vergleichbare Technologien</h2>
              <p>
                Unsere Website verwendet Cookies sowie Technologien, die mit Cookies vergleichbar
                sind (z.&nbsp;B. <code>localStorage</code>). Cookies sind kleine Textdateien, die
                über den Browser auf Ihrem Endgerät gespeichert werden.
              </p>

              <h3>6.1 Technisch notwendige Cookies</h3>
              <p>
                Wir setzen technisch notwendige Cookies und Speichereinträge ein, die für den
                Betrieb der Website unerlässlich sind. Hierzu zählt insbesondere die Speicherung
                Ihrer Cookie-Einstellungen.
              </p>
              <p>
                <strong>Rechtsgrundlage:</strong> § 25 Abs. 2 Nr. 2 TDDDG (vormals TTDSG) sowie
                Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen
                Bereitstellung).
              </p>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                <thead>
                  <tr style={{ background: 'var(--gray-100, #f3f4f6)' }}>
                    <th style={{ textAlign: 'left', padding: '0.5rem', border: '1px solid #e5e7eb' }}>Name</th>
                    <th style={{ textAlign: 'left', padding: '0.5rem', border: '1px solid #e5e7eb' }}>Anbieter</th>
                    <th style={{ textAlign: 'left', padding: '0.5rem', border: '1px solid #e5e7eb' }}>Zweck</th>
                    <th style={{ textAlign: 'left', padding: '0.5rem', border: '1px solid #e5e7eb' }}>Speicherdauer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: '0.5rem', border: '1px solid #e5e7eb' }}><code>cookieConsent</code></td>
                    <td style={{ padding: '0.5rem', border: '1px solid #e5e7eb' }}>IB Neubaur GmbH (eigenes localStorage)</td>
                    <td style={{ padding: '0.5rem', border: '1px solid #e5e7eb' }}>Speicherung Ihrer Cookie-Einstellungen</td>
                    <td style={{ padding: '0.5rem', border: '1px solid #e5e7eb' }}>12 Monate</td>
                  </tr>
                </tbody>
              </table>

              <h3 style={{ marginTop: '1.5rem' }}>6.2 Einwilligungspflichtige Cookies / externe Inhalte</h3>
              <p>
                Darüber hinaus binden wir Inhalte Dritter ein (z.&nbsp;B. Karten, Videos), bei
                denen Cookies oder vergleichbare Technologien gesetzt werden können. Diese werden
                <strong> ausschließlich nach Ihrer ausdrücklichen Einwilligung</strong> geladen
                (§ 25 Abs. 1 TDDDG i.V.m. Art. 6 Abs. 1 lit. a DSGVO).
              </p>
              <p>
                Sie können Ihre Cookie-Einstellungen jederzeit anpassen oder Ihre Einwilligung
                widerrufen:
              </p>
              <p>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={openCookieSettings}
                  style={{ marginTop: '0.5rem' }}
                >
                  Cookie-Einstellungen öffnen
                </button>
              </p>
            </div>

            {/* 7. Kontaktformular */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">7. Kontaktaufnahme und Kontaktformular</h2>
              <p>
                Auf unserer Website ist ein Kontaktformular vorhanden, welches für die
                elektronische Kontaktaufnahme genutzt werden kann. Nimmt ein Nutzer diese
                Möglichkeit wahr, so werden die in der Eingabemaske eingegebenen Daten an uns
                übermittelt und gespeichert. Diese Daten sind:
              </p>
              <ul>
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Thema der Anfrage</li>
                <li>Nachrichteninhalt</li>
                <li>Zeitpunkt der Übermittlung</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Beantwortung Ihrer Anfrage und ggf. Anbahnung eines
                Vertragsverhältnisses.<br />
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche
                Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
                Bearbeitung von Anfragen).<br />
                <strong>Speicherdauer:</strong> Die Daten werden gelöscht, sobald sie für die
                Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Bei
                gesetzlichen Aufbewahrungspflichten (z.&nbsp;B. Geschäftsbriefe, § 257 HGB)
                erfolgt die Löschung nach Ablauf der jeweiligen Frist.
              </p>

              <h3>7.1 Versand des Kontaktformulars über EmailJS</h3>
              <p>
                Für den technischen Versand der Kontaktformular-Daten setzen wir den
                Dienstleister
                <strong> EmailJS </strong>
                ein.
              </p>
              <p>
                <strong>Anbieter:</strong> EmailJS, Inc., 1390 Market Street, Suite 200,
                San Francisco, CA 94102, USA.
              </p>
              <p>
                Beim Absenden des Formulars werden die eingegebenen Daten über die Server von
                EmailJS verschlüsselt an unser E-Mail-Postfach weitergeleitet. Die Verarbeitung
                erfolgt ausschließlich zum Zweck der Zustellung Ihrer Nachricht an uns.
              </p>
              <p>
                <strong>Datenübermittlung in die USA:</strong> Eine Übermittlung in die USA findet
                statt. Die Übermittlung erfolgt auf Grundlage des EU-US Data Privacy Frameworks
                (Angemessenheitsbeschluss der EU-Kommission vom 10.07.2023 gemäß Art. 45 DSGVO),
                soweit der Anbieter unter dem Framework zertifiziert ist, ergänzend gestützt auf
                Standardvertragsklauseln nach Art. 46 Abs. 2 lit. c DSGVO.
              </p>
              <p>
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b und lit. f DSGVO.
              </p>
              <p>
                Mit dem Anbieter wurde ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO
                geschlossen. Weitere Informationen finden Sie in der Datenschutzerklärung des
                Anbieters: <a href="https://www.emailjs.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">https://www.emailjs.com/legal/privacy-policy/</a>
              </p>
            </div>

            {/* 8. Externe Inhalte – Google Maps */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">8. Einbindung von Google Maps</h2>
              <p>
                Wir binden auf unserer Website Karten des Dienstes „Google Maps" ein. Diese
                werden von der <strong>Google Ireland Limited</strong>, Gordon House, Barrow
                Street, Dublin 4, Irland („Google") betrieben. Verantwortliche Stelle für
                Nutzer in der EU/im EWR ist Google Ireland Limited.
              </p>
              <p>
                <strong>Click-to-Load:</strong> Google Maps wird auf unserer Website ausschließlich
                nach Ihrer ausdrücklichen Einwilligung geladen. Vor der Einwilligung sehen Sie
                lediglich einen Platzhalter; es findet keine Datenübertragung an Google statt.
                Erst nach Ihrer Einwilligung (Klick auf „Karte laden") wird die Karte geladen,
                und folgende Daten können an Google übermittelt werden:
              </p>
              <ul>
                <li>IP-Adresse</li>
                <li>Datum und Uhrzeit der Anfrage</li>
                <li>Inhalt der Anforderung</li>
                <li>Zugriffsstatus / HTTP-Statuscode</li>
                <li>Browser- und Geräteinformationen</li>
                <li>Standortdaten, sofern Sie diese in Ihrem Browser/Endgerät freigegeben haben</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Darstellung unserer Standorte, ansprechende Präsentation
                und einfache Auffindbarkeit unseres Unternehmens.<br />
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
                TDDDG (Einwilligung).<br />
                <strong>Datenübermittlung in die USA:</strong> Eine Datenübertragung in die USA
                kann nicht ausgeschlossen werden. Die Übermittlung erfolgt auf Grundlage des
                EU-US Data Privacy Frameworks (Angemessenheitsbeschluss vom 10.07.2023) sowie
                ergänzend auf Standardvertragsklauseln (Art. 46 DSGVO).<br />
                <strong>Speicherdauer:</strong> Wir selbst speichern keine Daten; die
                Speicherdauer bei Google entnehmen Sie deren Datenschutzerklärung.
              </p>
              <p>
                Sie können Ihre Einwilligung jederzeit über die{' '}
                <button
                  type="button"
                  onClick={openCookieSettings}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--accent-color, #0066cc)',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    padding: 0,
                    font: 'inherit'
                  }}
                >
                  Cookie-Einstellungen
                </button>{' '}
                widerrufen.
              </p>
              <p>
                Datenschutzerklärung von Google:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
                <br />
                Opt-Out-Möglichkeit:{' '}
                <a href="https://adssettings.google.com/" target="_blank" rel="noopener noreferrer">
                  https://adssettings.google.com/
                </a>
              </p>
            </div>

            {/* 9. YouTube */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">9. Einbindung von YouTube-Videos</h2>
              <p>
                Wir binden auf einzelnen Seiten Videos der Plattform YouTube ein. Anbieter ist
                die <strong>Google Ireland Limited</strong>, Gordon House, Barrow Street,
                Dublin 4, Irland.
              </p>
              <p>
                <strong>Click-to-Load &amp; erweiterter Datenschutz-Modus:</strong> YouTube-Videos
                werden ausschließlich nach Ihrer ausdrücklichen Einwilligung geladen. Wir nutzen
                den erweiterten Datenschutz-Modus von YouTube
                (<code>youtube-nocookie.com</code>), wodurch nach Anbieterangaben keine Cookies
                gesetzt werden, solange Sie kein Video abspielen. Beim Abspielen eines Videos
                können dennoch Daten an Google übertragen werden.
              </p>
              <p>
                Folgende Daten können beim Abspielen eines Videos verarbeitet werden:
              </p>
              <ul>
                <li>IP-Adresse</li>
                <li>Datum und Uhrzeit</li>
                <li>Aufgerufene URL und Browserdaten</li>
                <li>Geräteinformationen</li>
                <li>Bei eingeloggten Google-Konten: Zuordnung zum Profil</li>
              </ul>
              <p>
                <strong>Zweck:</strong> Anschauliche Darstellung unserer Leistungen mittels
                Videoinhalten.<br />
                <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
                TDDDG.<br />
                <strong>Datenübermittlung in die USA:</strong> Erfolgt unter den Garantien des
                EU-US Data Privacy Frameworks (Art. 45 DSGVO) sowie der Standardvertragsklauseln
                (Art. 46 DSGVO).
              </p>
              <p>
                Datenschutzerklärung von YouTube/Google:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </p>
            </div>

            {/* 10. Rechte der betroffenen Person */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">10. Rechte der betroffenen Person</h2>
              <p>
                Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie Betroffener im
                Sinne der DSGVO und es stehen Ihnen folgende Rechte gegenüber dem
                Verantwortlichen zu:
              </p>
              <ul>
                <li>
                  <strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie haben das Recht, eine
                  Bestätigung darüber zu verlangen, ob Sie betreffende personenbezogene Daten
                  verarbeitet werden.
                </li>
                <li>
                  <strong>Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie haben das Recht
                  auf Berichtigung und/oder Vervollständigung gegenüber dem Verantwortlichen,
                  sofern die verarbeiteten Daten unrichtig oder unvollständig sind.
                </li>
                <li>
                  <strong>Recht auf Löschung (Art. 17 DSGVO):</strong> Sie haben das Recht zu
                  verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht
                  werden.
                </li>
                <li>
                  <strong>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie
                  haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
                  Daten zu verlangen.
                </li>
                <li>
                  <strong>Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das
                  Recht, Ihre personenbezogenen Daten in einem strukturierten, gängigen und
                  maschinenlesbaren Format zu erhalten.
                </li>
                <li>
                  <strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie haben das Recht, aus
                  Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die
                  Verarbeitung Sie betreffender personenbezogener Daten Widerspruch einzulegen.
                </li>
                <li>
                  <strong>Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie
                  haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu
                  widerrufen. Durch den Widerruf wird die Rechtmäßigkeit der aufgrund der
                  Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
                </li>
                <li>
                  <strong>Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO):</strong>
                  &nbsp;Unbeschadet eines anderweitigen verwaltungsrechtlichen oder
                  gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer
                  Aufsichtsbehörde zu.
                </li>
              </ul>
              <p>
                Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an{' '}
                <a href="mailto:info@neubaur-gmbh.de">info@neubaur-gmbh.de</a>.
              </p>
            </div>

            {/* 11. Zuständige Aufsichtsbehörde */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">11. Zuständige Aufsichtsbehörde</h2>
              <p>
                Für uns zuständige Datenschutz-Aufsichtsbehörde ist:
              </p>
              <p>
                <strong>Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)</strong><br />
                Promenade 18<br />
                91522 Ansbach<br />
                Telefon: +49 (0) 981 180093-0<br />
                E-Mail: <a href="mailto:poststelle@lda.bayern.de">poststelle@lda.bayern.de</a><br />
                Web: <a href="https://www.lda.bayern.de" target="_blank" rel="noopener noreferrer">www.lda.bayern.de</a>
              </p>
            </div>

            {/* 12. Pflicht zur Bereitstellung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">12. Pflicht zur Bereitstellung der Daten</h2>
              <p>
                Sie sind weder gesetzlich noch vertraglich zur Bereitstellung Ihrer
                personenbezogenen Daten verpflichtet. Allerdings können wir bestimmte Angebote nur
                eingeschränkt oder gar nicht erbringen, wenn Sie die hierzu erforderlichen Daten
                nicht bereitstellen (z.&nbsp;B. die Bearbeitung Ihrer Anfrage über das
                Kontaktformular).
              </p>
            </div>

            {/* 13. Automatisierte Entscheidungsfindung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">13. Automatisierte Entscheidungsfindung</h2>
              <p>
                Eine automatisierte Entscheidungsfindung einschließlich Profiling gemäß Art. 22
                DSGVO findet nicht statt.
              </p>
            </div>

            {/* 14. Änderungen */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 className="service-section-title">14. Aktualität und Änderung dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Mai 2026. Durch
                die Weiterentwicklung unserer Website und Angebote oder aufgrund geänderter
                gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden,
                diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung
                kann jederzeit auf dieser Website abgerufen und ausgedruckt werden.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
